import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';
import queryString from 'query-string';

import * as styles from '../../styles';
import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';
import {refresh as paginatorRefresh, updateItem, setSort, clearSelection, setData, removeItem} from '../../paginator/actions';
import Dialog from '../../dialog/dialog';
import PaginatedContainer from '../../paginator/paginated_container';
import {request} from '../../containers/actions';
import {setUnreadMessages} from '../../containers/actions';


export default class Messages extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: false,
        actions: [],
        buttonActions: [],
    }

    state = {
        box: 'inbox',
    }

    listFieldsSelector = createSelector(
        [
            () => this.state.box,
        ],
        box => [
            ...(this.props.admin ? [{field: 'id', label: window.gettext('ID')}] : []),
            {
                field: item => <div
                    title={item.subject}
                    style={{
                        fontWeight: (box === 'sent' ? item.seen_by.length > 0 : item.read) ? 'normal' : 'bold',
                        width: this.props.admin || box === 'archived' ? '6em' : '12em',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                    }}>
                    {item.attachments.files.length > 0
                        ? <i className='fa-attachment'>&nbsp;</i>
                        : null
                    }
                    {item.subject || <i>&lt;{window.gettext('No Subject')}&gt;</i>}
                </div>,
                label: window.pgettext('message', 'Subject'),
            },
            ...(box === 'inbox'
                ? [
                    {
                        field: item => <div
                            title={`${item.sender.firstname} ${item.sender.lastname}`}
                            style={{
                                fontWeight: (box === 'sent' ? item.seen_by.length > 0 : item.read) ? 'normal' : 'bold',
                                width: this.props.admin ? '7em' : '9em',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                            }}>
                            {item.sender.firstname} {item.sender.lastname}
                        </div>,
                        label: window.gettext('Sender'),
                    },
                    ...(this.props.admin
                        ? [{
                            field: item => <div
                                title={_.map(item.recipients, user => `${user.firstname} ${user.lastname} - ${(user.username || '').persian()}`).join('\n')}
                                style={{
                                    width: this.props.admin ? '7em' : '9em',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}>
                                {_.map(
                                    item.recipients,
                                    recipient => <div
                                        key={recipient.id}
                                        style={styles.tag}>
                                        {recipient.firstname} {recipient.lastname}
                                    </div>,
                                )}
                            </div>,
                            label: window.gettext('Recipients'),
                        }]
                        : []
                    ),
                ]
                : box === 'sent'
                    ? [
                        ...(this.props.admin
                            ? [{
                                field: item => <div
                                    title={`${item.sender.firstname} ${item.sender.lastname}`}
                                    style={{
                                        fontWeight: (box === 'sent' ? item.seen_by.length > 0 : item.read) ? 'normal' : 'bold',
                                        width: this.props.admin ? '7em' : '9em',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}>
                                    {item.sender.firstname} {item.sender.lastname}
                                </div>,
                                label: window.gettext('Sender'),
                            }]
                            : []
                        ),
                        {
                            field: item => <div
                                title={_.map(item.recipients, user => `${user.firstname} ${user.lastname} - ${(user.username || '').persian()}`).join('\n')}
                                style={{
                                    width: this.props.admin ? '7em' : '9em',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}>
                                {_.map(
                                    item.recipients,
                                    recipient => <div
                                        key={recipient.id}
                                        style={styles.tag}>
                                        {recipient.firstname} {recipient.lastname}
                                    </div>,
                                )}
                            </div>,
                            label: window.gettext('Recipients'),
                        },
                    ]
                    : box === 'archived'
                        ? [
                            {
                                field: item => <div
                                    title={`${item.sender.firstname} ${item.sender.lastname}`}
                                    style={{
                                        fontWeight: (box === 'sent' ? item.seen_by.length > 0 : item.read) ? 'normal' : 'bold',
                                        width: '7em',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}>
                                    {item.sender.firstname} {item.sender.lastname}
                                </div>,
                                label: window.gettext('Sender'),
                            },
                            {
                                field: item => <div
                                    title={_.map(item.recipients, user => `${user.firstname} ${user.lastname} - ${(user.username || '').persian()}`).join('\n')}
                                    style={{
                                        width: '7em',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}>
                                    {_.map(
                                        item.recipients,
                                        recipient => <div
                                            key={recipient.id}
                                            style={styles.tag}>
                                            {recipient.firstname} {recipient.lastname}
                                        </div>,
                                    )}
                                </div>,
                                label: window.gettext('Recipients'),
                            },
                        ]
                        : []
            ),
            {
                field: item => <span style={{fontSize: '.9em'}}>
                    {item.timestamp.toJalali().persian('YYYY/MM/DD - hh:mm:ss')}
                </span>,
                label: window.gettext('Date'),
                style: {direction: 'ltr'},
            },
            ...(this.props.admin && box === 'sent'
                ? [
                    {
                        field: item => <span
                            title={_.map(
                                item.seen_by,
                                user => {
                                    user = _.find(item.recipients, recipient => recipient.id === user.id);
                                    return `${user.firstname} ${user.lastname} - ${(user.username || '').persian()}`;
                                },
                            ).join('\n')}
                            style={{unicodeBidi: 'isolate-override'}}>
                            {item.seen_by.length.persian() + '/' + item.recipients.length.persian()}
                        </span>,
                        label: window.gettext('Seen by'),
                    },
                ]
                : []
            ),
        ],
    )

    filtersSelector = createSelector.bind(this)(
        [
            () => this.state.box,
            () => this.props.store.getIn(['userTypesTreeFilter']),
            () => this.props.store.getIn(['regionsTreeFilter']),
            () => this.props.store.getIn(['citiesTreeFilter']),
            () => this.props.store.getIn(['schoolsTreeFilter']),
        ],
        box => [
            ...(box === 'inbox' && !this.props.admin
                ? [{field: 'inbox', selected: {True: null}}]
                : box === 'sent' && !this.props.admin
                    ? [{field: 'sent', selected: {True: null}}]
                    : []
            ),
            ...(box === 'archived'
                ? [{field: 'archived', selected: {True: null}}]
                : [{field: 'archived', selected: {False: null}}]
            ),
            {
                field: box === 'inbox' ? 'sender_user_type' : box === 'sent' ? 'recipients_user_type' : 'user_type',
                label: window.gettext('User Type'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('userTypesTreeFilter')}
                        readonly
                        header
                        resource='user-type'
                        label={window.gettext('User Type')}
                        staticItems={_.mapValues(Array(8), (__, index) => ({id: index, label: window.pgettext('user-type', 'Type-' + index)}))}
                    />
                </div>,
                selected: this.props.store.getIn(['userTypesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'user-type',
                    this.props.store.getIn(['userTypesTreeFilter', 'elementId']),
                )),
            },
            {
                field: box === 'inbox' ? 'sender_region' : box === 'sent' ? 'recipients_region' : 'region',
                label: window.gettext('Region'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('regionsTreeFilter')}
                        readonly
                        header
                        resource='region'
                        itemLabel='name'
                        label={window.gettext('Region')}
                    />
                </div>,
                selected: this.props.store.getIn(['regionsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'region',
                    this.props.store.getIn(['regionsTreeFilter', 'elementId']),
                )),
            },
            {
                field: box === 'inbox' ? 'sender_city' : box === 'sent' ? 'recipients_city' : 'city',
                label: window.gettext('City'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('citiesTreeFilter')}
                        readonly
                        header
                        resource='city'
                        itemLabel={city => `${city.region_display} - ${city.name}`}
                        filter={{
                            'region': this.props.store.getIn(['regionsTreeFilter', 'selected']).keySeq().join(',') || -1,
                        }}
                        label={window.gettext('City')}
                    />
                </div>,
                selected: this.props.store.getIn(['citiesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'city',
                    this.props.store.getIn(['citiesTreeFilter', 'elementId']),
                )),
            },
            {
                field: box === 'inbox' ? 'sender_school' : box === 'sent' ? 'recipients_school' : 'school',
                label: window.gettext('School'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('schoolsTreeFilter')}
                        readonly
                        header
                        resource='school'
                        itemLabel={school => `${school.city.name} - ${school.name}`}
                        filter={{
                            'city': this.props.store.getIn(['citiesTreeFilter', 'selected']).keySeq().join(',') || -1,
                        }}
                        label={window.gettext('School')}
                    />
                </div>,
                selected: this.props.store.getIn(['schoolsTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'school',
                    this.props.store.getIn(['schoolsTreeFilter', 'elementId']),
                )),
            },
        ],
    )

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size,
        ],
        () => this.props.readonly
            ? this.props.actions
            : _.concat(
                this.props.actions,
                this.props.store.getIn(['paginator', 'selected']).size > 0
                    ? [
                    ]
                    : [],
            ),
    )

    buttonActionsSelector = createSelector(
        [
            () => this.props.store.getIn(['paginator', 'selected']).size,
            () => this.state.box,
            () => this.props.actions,
            () => this.props.readonly,
        ],
        (size, box) => this.props.readonly
            ? this.props.buttonActions
            : _.concat(
                this.props.buttonActions,
                size
                    ? this.props.admin
                        ? [
                            {
                                label: window.gettext('Remove'),
                                action: async () => {
                                    if (!window.confirm(window.interpolate(
                                        window.gettext('Are you sure you wanna remove these %(count)s messages?'),
                                        {count: this.props.store.getIn(['paginator', 'selected']).size.persian()},
                                        true,
                                    )))
                                        return;
                                    await this.context.store.dispatch(request({
                                        path: '/message/?' + queryString.stringify({
                                            id: this.props.store.getIn(['paginator', 'selected']).keySeq().join(','),
                                        }),
                                        method: 'DELETE',
                                    }));
                                    this.context.store.dispatch([
                                        ...this.props.store.getIn(['paginator', 'selected']).map(
                                            (__, id) => removeItem(id, this.props.store.getIn(['paginator', 'elementId'])),
                                        ).toArray(),
                                        clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                    ]);
                                },
                            },
                        ]
                        : [
                            {
                                label: window.gettext('Mark Read'),
                                action: async () => {
                                    if (!window.confirm(window.gettext('Are you sure you want to mark selected messages as read?')))
                                        return;
                                    await this.context.store.dispatch(request({
                                        path: '/message/',
                                        body: this.props.store.getIn(['paginator', 'selected']).map(item => ({
                                            id: item.get('id'),
                                            read: true,
                                        })).toArray(),
                                        method: 'PATCH',
                                    }));
                                    this.context.store.dispatch([
                                        clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                        paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                        setUnreadMessages(
                                            this.context.store.getState().getIn(['application', 'unreadMessages']) -
                                this.props.store.getIn(['paginator', 'selected']).filter(message => !message.get('read')).size
                                        ),
                                    ]);
                                },
                            },
                            {
                                label: window.gettext('Mark Unread'),
                                action: async () => {
                                    if (!window.confirm(window.gettext('Are you sure you want to mark selected messages as unread?')))
                                        return;
                                    await this.context.store.dispatch(request({
                                        path: '/message/',
                                        body: this.props.store.getIn(['paginator', 'selected']).map(item => ({
                                            id: item.get('id'),
                                            read: false,
                                        })).toArray(),
                                        method: 'PATCH',
                                    }));
                                    this.context.store.dispatch([
                                        clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                        paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                        setUnreadMessages(
                                            this.context.store.getState().getIn(['application', 'unreadMessages']) +
                                this.props.store.getIn(['paginator', 'selected']).filter(message => message.get('read')).size
                                        ),
                                    ]);
                                },
                            },
                            {
                                label: box === 'archived' ? window.gettext('Unarchive') : window.gettext('Archive'),
                                action: async () => {
                                    if (!window.confirm(
                                        box === 'archived'
                                            ? window.gettext('Are you sure you want to unarchive selected messages?')
                                            : window.gettext('Are you sure you want to archive selected messages?'),
                                    ))
                                        return;
                                    await this.context.store.dispatch(request({
                                        path: '/message/',
                                        body: this.props.store.getIn(['paginator', 'selected']).map(item => ({
                                            id: item.get('id'),
                                            archived: box !== 'archived',
                                        })).toArray(),
                                        method: 'PATCH',
                                    }));
                                    this.context.store.dispatch([
                                        clearSelection(this.props.store.getIn(['paginator', 'elementId'])),
                                        paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])),
                                        setUnreadMessages(
                                            this.context.store.getState().getIn(['application', 'unreadMessages']) + (box === 'archived' ? 1 : -1) *
                                this.props.store.getIn(['paginator', 'selected']).filter(message => !message.get('read')).size
                                        ),
                                    ]);
                                },
                            },
                        ]
                    : [
                        ...(this.props.admin
                            ? []
                            : [{
                                label: window.gettext('New Message'),
                                action: () => {
                                    let path = this.context.store.getState().getIn(
                                        ['routing', 'locationBeforeTransitions', 'pathname'],
                                    );
                                    if (this.props.params.id) {
                                        path = path.split('/').slice(0, -2).join('/') + '/';
                                    }
                                    path += 'compose/';
                                    this.context.store.dispatch(push(path));
                                },
                                style: {backgroundColor: styles.fourthColor},
                                default: true,
                            }]
                        ),
                        {
                            label: window.gettext('Inbox'),
                            action: async () => {
                                await this.context.store.dispatch(setData([], this.props.store.getIn(['paginator', 'elementId'])));
                                this.setState({box: 'inbox'});
                            },
                            style: {
                                borderTop: 'none',
                                borderBttom: 'none',
                                borderLeft: 'none',
                                borderRight: 'none',
                                boxShadow: 'none',
                                backgrdounColor: 'transparent',
                                color: box === 'inbox' ? styles.selectedColor : 'black',
                                minWidth: undefined,
                                fontWeight: 500,
                            },
                        },
                        {
                            label: window.gettext('Sent'),
                            action: async () => {
                                await this.context.store.dispatch(setData([], this.props.store.getIn(['paginator', 'elementId'])));
                                this.setState({box: 'sent'});
                            },
                            style: {
                                borderTop: 'none',
                                borderBttom: 'none',
                                borderLeft: 'none',
                                borderRight: 'none',
                                boxShadow: 'none',
                                backgrdounColor: 'transparent',
                                color: box === 'sent' ? styles.selectedColor : 'black',
                                minWidth: undefined,
                                fontWeight: 500,
                            },
                        },
                        {
                            label: window.gettext('Archived'),
                            action: async () => {
                                await this.context.store.dispatch(setData([], this.props.store.getIn(['paginator', 'elementId'])));
                                this.setState({box: 'archived'});
                            },
                            style: {
                                borderTop: 'none',
                                borderBttom: 'none',
                                borderLeft: 'none',
                                borderRight: 'none',
                                boxShadow: 'none',
                                backgrdounColor: 'transparent',
                                color: box === 'archived' ? styles.selectedColor : 'black',
                                minWidth: undefined,
                                fontWeight: 500,
                            },
                        },
                    ],
            ),
    )

    eventHandlers = {
        onClick: item => {
            if (!this.props.readonly) {
                let path = this.context.store.getState().getIn(
                    ['routing', 'locationBeforeTransitions', 'pathname'],
                );
                if (this.props.params.id) {
                    path = path.split('/').slice(0, -2).join('/') + '/';
                }
                path += `${item.id}/`;
                this.context.store.dispatch([
                    push(path),
                    updateItem({...item, read: true}, this.props.store.getIn(['paginator', 'elementId'])),
                ]);
            }
        },
    }

    constructor(props) {
        super(props);
        this.tooltip = this.tooltip.bind(this);
    }

    componentWillMount() {
        const prefix = this.state.box === 'inbox' ? 'sender_' : 'recipients_';
        this.context.store.dispatch(setSort(
            this.props.admin
                ? [
                    {name: 'id', label: window.gettext('ID'), reversed: true},
                    {name: prefix + 'national_id', label: window.gettext('national id')},
                    {name: prefix + 'firstname', label: window.gettext('firstname')},
                    {name: prefix + 'lastname', label: window.gettext('lastname')},
                ]
                : [
                    {name: prefix + 'firstname', label: window.gettext('firstname')},
                    {name: prefix + 'lastname', label: window.gettext('lastname')},
                ],
            this.props.store.getIn(['paginator', 'elementId']),
        ));
    }

    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.params && prevProps.params.id) !== (this.props.params && this.props.params.id)) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
        if (prevState.box !== this.state.box) {
            const prefix = this.state.box === 'inbox' ? 'sender_' : 'recipients_';
            this.context.store.dispatch(setSort(
                this.props.admin
                    ? [
                        {name: 'id', label: window.gettext('ID'), reversed: true},
                        {name: prefix + 'national_id', label: window.gettext('national id')},
                        {name: prefix + 'firstname', label: window.gettext('firstname')},
                        {name: prefix + 'lastname', label: window.gettext('lastname')},
                    ]
                    : [
                        {name: prefix + 'firstname', label: window.gettext('firstname')},
                        {name: prefix + 'lastname', label: window.gettext('lastname')},
                    ],
                this.props.store.getIn(['paginator', 'elementId']),
            ));
        }
    }

    tooltip(item) {
        return item.body;
    }

    render() {
        return <span>
            <div style={{width: '49em', float: 'right'}}>
                <PaginatedContainer
                    store={this.props.store.get('paginator')}
                    resource='message'
                    title={window.gettext('Messages')}
                    listFields={this.listFieldsSelector(this.props.store, this.state)}
                    tooltip={this.tooltip}
                    readonly={this.props.readonly}
                    selectable
                    filters={this.filtersSelector(this.props.store, this.state)}
                    pageSize={this.props.pageSize}
                    actions={this.actionsSelector(this.props.store)}
                    buttonActions={this.buttonActionsSelector(this.props.store, this.state)}
                    events={this.eventHandlers}
                />
            </div>
            {this.props.children && this.props.params.id !== 'compose'
                ? <div
                    style={{
                        float: 'right',
                        width: 'calc(100% - 49.5em)',
                        backgroundColor: '#fafafa',
                        padding: '1em',
                        marginRight: '.5em',
                        boxSizing: 'border-box',
                        marginTop: '4em',
                    }}>
                    {this.props.children}
                </div>
                : null
            }
            {this.props.children && this.props.params.id === 'compose'
                ? <Dialog
                    isOpen
                    easyCancel={false}
                    onClose={() => this.context.store.dispatch(push(this.context.store.getState().getIn(
                        ['routing', 'locationBeforeTransitions', 'pathname'],
                    ).split('/').slice(0, -2).join('/') + '/'))}>
                    <div style={{width: '50em'}}>
                        {this.props.children}
                    </div>
                    {window.gettext('Compose')}
                </Dialog>
                : null
            }
        </span>;
    }
}
